import React from 'react';
import classNames from 'classnames';
import { IMarketingManagerOpportunityResponse } from 'services/MarketingManagerApi';
import { ContentImage } from './ContentImage';
import { formatDateDisplay } from 'utils/date';
import { getCurrencySymbol } from 'utils/currency';
import { formatPrice } from 'utils';
import { SvgIcon } from 'ui/SvgIcon';
import CalendarIcon from 'ui/Icons/calendar.component.svg';
import ImageIcon from 'ui/Icons/tabler/image.component.svg';
import FluidButton from 'ui/FluidButton';
import { LineClampComponent } from 'containers/ReviewPage/LineClampComponent';
import { HtmlStringRenderer } from 'components/HtmlStringRenderer';

interface IContentCardProps {
  item: IMarketingManagerOpportunityResponse;
  onViewDetails?: (uuid: string) => void;
}

export const ContentCard: React.FC<IContentCardProps> = ({ item, onViewDetails }) => {
  const hasDiscount = item.discountedPrice != null && item.currency && item.discountedPrice! > 0;
  const currencySymbol = item.currency ? getCurrencySymbol(item.currency as any) : '';

  const stayPeriod =
    item.stayPeriodStart && item.stayPeriodEnd
      ? `Stay BETWEEN ${formatDateDisplay(item.stayPeriodStart)} AND ${formatDateDisplay(item.stayPeriodEnd)}`
      : null;

  const hasHeroImage = item.heroImage && item.heroImage.sizes;

  return (
    <div className="bg-gray-light flex flex-col gap-25px">
      <div className="relative">
        {hasHeroImage ? (
          <ContentImage upload={item.heroImage!} index={0} imgClassName="!h-[240px]" />
        ) : (
          <div className="h-[240px] bg-gray-100 flex items-center justify-center">
            <div className="text-center text-gray-400">
              <SvgIcon IconComponent={ImageIcon} className="w-10 h-10 fill-gray-400 mb-2" />
              <div className="text-sm">No image available</div>
            </div>
          </div>
        )}
        {item.isExclusive && (
          <span className="absolute top-[10px] left-[10px] bg-brown-prime text-white font-hurmegeometric-sans px-[6px] py-[3px] text-14px tracking-1px h-[30px] flex items-center">Exclusive</span>
        )}
        {hasDiscount && (
          <span className="absolute bottom-[15px] left-[15px] bg-white-true text-red-92 px-[6px] py-[3px] text-[20px] min-w-[110px]">
            {currencySymbol}
            {formatPrice(item.discountedPrice!)}
          </span>
        )}
      </div>

      <div className="px-[15px] flex flex-col justify-between gap-15px flex-1 mb-25px">
        <div className="text-19px text-brown-prime font-noe-display">{item.title}</div>
        {stayPeriod && (
          <div className="text-13px font-semibold text-gray-100 flex items-center gap-5px">
            <SvgIcon IconComponent={CalendarIcon} className="w-[15px] fill-brown-prime" />
            {stayPeriod}
          </div>
        )}
        <LineClampComponent lines={3}
          content={
            <HtmlStringRenderer content={item.shortDescription?.content || ''} />
          }
        />
        {onViewDetails && (
          <FluidButton
            className="w-full rounded-none font-hurmegeometric-sans uppercase font-normal"
            type="primary"
            onClick={() => onViewDetails(item.uuid)}
          >
            View Details
          </FluidButton>
        )}
      </div>
    </div>
  );
};

export default ContentCard;


